import { render, staticRenderFns } from "./versionOrder.vue?vue&type=template&id=57a1ad4a&scoped=true"
import script from "./versionOrder.vue?vue&type=script&lang=js"
export * from "./versionOrder.vue?vue&type=script&lang=js"
import style0 from "./versionOrder.vue?vue&type=style&index=0&id=57a1ad4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a1ad4a",
  null
  
)

export default component.exports